import $ from 'jquery';
import { useEffect } from 'react';
import m from '../../prime-src/prepare';

export default function SidebarDragger({ opened, setOpened }) {
	useEffect(() => {
		if (window.innerWidth < 700) {
      setOpened(draft => ({ ...draft, value: false }));
    }
		m.$window.on("resize.sidebar", function () {
			setOpened(draft => {
				draft.count = draft.count + 1;
				if (window.innerWidth < 700) {
					draft.value = false;
					m.$sidebar.css({ marginLeft: -m.$sidebar.outerWidth() });
					m.$sidebar_dragger.css({ left: 0 });
				} else {
					draft.value = true;
					m.$sidebar.css({ marginLeft: 0 });
					m.$sidebar_dragger.css({ left: m.$sidebar.outerWidth() });
				}
				return { ...draft };
			});
		});
	}, []);

	return (
		<div id="sidebar-dragger" data-count={opened.count} style={{left: opened.value ? ($("#sidebar").length ? $("#sidebar").outerWidth() : window.innerWidth >= 900 ? '20em' : '15em') : 0}}>
			<svg id="sidebar-toggle" onClick={() => {
				setOpened(o => {
					if (o.value) {
						m.$sidebar.css({"margin-left":`${-m.$sidebar.outerWidth()}px`});
					} else {
						m.$sidebar.css({"margin-left":0});
					}
					return {...o, value:!o.value, count:o.count+1}
				});
			}}>
				{opened.value ?
				<g>
					<line x1="20%" y1="50%" x2="80%" y2="50%"></line>
					<line x1="20%" y1="50%" x2="50%" y2="20%"></line>
					<line x1="20%" y1="50%" x2="50%" y2="80%"></line>
				</g> :
				<g>
					<line x1="20%" y1="50%" x2="80%" y2="50%"></line>
					<line x1="80%" y1="50%" x2="50%" y2="20%"></line>
					<line x1="80%" y1="50%" x2="50%" y2="80%"></line>
				</g>}
			</svg>
			<div id="sidebar-dragger-in"></div>
		</div>
	);
}
